/**
 * URL参数处理工具
 */
class UrlUtils {
  /**
   * 获取URL参数
   * @param {string} name 参数名
   * @returns {string|null} 参数值
   */
  getUrlParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * 设置URL参数
   * @param {string} name 参数名
   * @param {string} value 参数值
   */
  setUrlParam(name, value) {
    const url = new URL(window.location);
    url.searchParams.set(name, value);
    window.history.replaceState({}, '', url);
  }

  /**
   * 移除URL参数
   * @param {string} name 参数名
   */
  removeUrlParam(name) {
    const url = new URL(window.location);
    url.searchParams.delete(name);
    window.history.replaceState({}, '', url);
  }

  /**
   * 检查是否是登录回调
   * @returns {boolean}
   */
  isLoginCallback() {
    return this.getUrlParam('token') !== null;
  }

  /**
   * 处理登录回调
   * @returns {string|null} token
   */
  handleLoginCallback() {
    const token = this.getUrlParam('token');
    if (token) {
      // 清除URL中的token参数
      this.removeUrlParam('token');
      return token;
    }
    return null;
  }
}

export default new UrlUtils();
